app.service('articleView', function(localStorage, console, modal, loading) {
	var $header;

	function init() {
		$header=$('#top');

		$('#article-links a[href*="#"]').click(function(e){
			e.preventDefault();
			var elementOffset = $(this.hash).offset();
			if(elementOffset) {
				$.scrollTo(elementOffset.top - $header.outerHeight(), 500);
			}
		});

		$('.article-related-products').each(function(i) {
			$('.article-related-products-'+i).productSlider();
		});
	}

	return {
		init: init
	};
});
